import {SET_CATEGORIES, SET_FAMILIES, SET_LANGUAGE, SET_PRODUCT_IMAGES, SET_PRODUCTS, SET_CONTENTS} from './types'

export const setLanguage = language => ({type: SET_LANGUAGE, payload: language});
export const setFamilies = families => ({type: SET_FAMILIES, payload: families});
export const setCategories = categories => ({type: SET_CATEGORIES, payload: categories});
export const setProducts = products => ({type: SET_PRODUCTS, payload: products});
export const setProductImages = productImages => ({type: SET_PRODUCT_IMAGES, payload: productImages});
export const setContents = contents => ({type: SET_CONTENTS, payload: contents});
